import React, { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

const Gallery = ({ isOpen, contentType, onClose }) => {
  const swiperRef = useRef(null);

  useEffect(() => {
      if (isOpen && swiperRef.current && swiperRef.current.swiper) {
          const swiperInstance = swiperRef.current.swiper;

          const handleSlideChange = () => {
              const videos = document.querySelectorAll('.swiper-slide video');
              videos.forEach((video) => {
                  video.pause();
              });
          };

          swiperInstance.on('slideChange', handleSlideChange);

          
          return () => {
              swiperInstance.off('slideChange', handleSlideChange);
          };
      }
  }, [isOpen])

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
      if (e.target.className === 'gallery-overlay') {
          onClose();
      }
  };

    return (
      <div className="gallery-overlay" onClick={handleOverlayClick}>
          <button className="gallery-close" onClick={onClose}>x</button>
          {contentType === 'gallery' && (
            <div className="gallery-images">
              {<Swiper 
                navigation={true} 
                modules={[ Navigation]} className="galSwiper">
                <SwiperSlide>
                    <img src="img/SIDEEVENT-15APRIL/IMG_0344.jpg" alt="Side Event"></img>
                </SwiperSlide>
                <SwiperSlide>
                    <img src="img/SIDEEVENT-15APRIL/IMG_0343.jpg" alt="Side Event"></img>
                </SwiperSlide>
                <SwiperSlide>
                    <img src="img/SIDEEVENT-15APRIL/l1340844_53656374750_o.jpg" alt="Side Event"></img> 
                </SwiperSlide>
                <SwiperSlide>
                    <img src="img/SIDEEVENT-15APRIL/q1170920_53656263479_o.jpg" alt="Side Event"></img>
                </SwiperSlide>
              </Swiper>}
            </div>
          )}
          {contentType === 'video' && (
            <div className="gallery-video">
              {
                <video controls className="slide-video" >
                  <source src="video/EVI LAZOU - LASKARIDIS - COMMITMENTS ANNOUNCEMENT-FULL VIDEO HD.mp4" type="video/mp4"/>
                </video>
              }
            </div>
          )}
          {contentType === 'both' && (
            <div className="gallery-images">
              {<Swiper 
                ref={swiperRef}
                navigation={true} 
                modules={[ Navigation]} className="galSwiper">
                <SwiperSlide>
                    <img src="img/SIDEEVENT-17 APRIL(1)/gxg_1309_53662440108_o.jpg" alt="Side Event"></img>
                </SwiperSlide>
                <SwiperSlide>
                    <img src="img/SIDEEVENT-17 APRIL(1)/gxg_1233_53662222586_o.jpg" alt="Side Event"></img>
                </SwiperSlide>
                <SwiperSlide>
                    <img src="img/SIDEEVENT-17 APRIL(1)/xig_3831_53661351447_o.jpg" alt="Side Event"></img> 
                </SwiperSlide>
                <SwiperSlide>
                    <img src="img/SIDEEVENT-17 APRIL(1)/xig_3885_53661351557_o.jpg" alt="Side Event"></img>
                </SwiperSlide>
                <SwiperSlide>
                    <img src="img/SIDEEVENT-17APRIL/IMG_8463.jpg" alt="Side Event"></img>
                </SwiperSlide>
                <SwiperSlide>
                    <video controls className="slide-video">
                      <source src="video/H.A.H. THE ECUMENICAL PATRIARCH BARTHOLOMEW.mp4" type="video/mp4"/>
                    </video>
                </SwiperSlide>
                <SwiperSlide>
                    <video controls className="slide-video">
                      <source src="video/EVI LAZOU - LASKARIDIS.mp4" type="video/mp4"/>
                    </video>
                </SwiperSlide>
                <SwiperSlide>
                    <video controls className="slide-video">
                      <source src="video/MARIA DAMANAKI.mp4" type="video/mp4"/>
                    </video>
                </SwiperSlide>
                <SwiperSlide>
                    <video controls className="slide-video" >
                      <source src="video/GEORGE PAPATHEODOROU.mp4" type="video/mp4"/>
                    </video>
                </SwiperSlide>
                <SwiperSlide>
                    <video controls className="slide-video">
                      <source src="video/CYRILL GUTSCH.mp4" type="video/mp4"/>
                    </video>
                </SwiperSlide>
                <SwiperSlide>
                    <video controls className="slide-video">
                      <source src="video/MAXINE BURKETT.mp4" type="video/mp4"/>
                    </video>
                </SwiperSlide>
              </Swiper>}
            </div>    
          )}
          {contentType === 'video-large' && (
            <div className="gallery-video">
              {<iframe  src="https://www.youtube.com/embed/wK-L8QT3Cj8?si=yD2lhfnIw42AcAFt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>}
            </div>
          )}
          {contentType === 'typhoon' && (
            <div className="gallery-images">
                {
                    <Swiper 
                    navigation={true} 
                    modules={[ Navigation]} className="typSwiper">
                    <SwiperSlide>
                        <img src="img/typhoon/IMG_0188.jpg" alt="typhoon"></img>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src="img/typhoon/659b75b3-738b-4110-83e5-bb0d714e11c0.jpg" alt="typhoon"></img>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src="img/typhoon/9a3830f6-bf6a-4b34-82ba-2950047d85e2.jpg" alt="typhoon"></img>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src="img/typhoon/DSCF2815.jpg" alt="typhoon"></img> 
                    </SwiperSlide>
                  </Swiper>
                }
            </div>
          )}
    </div>

    );
  };

export default Gallery;
